import React from 'react';
import { useIonAlert, useIonToast } from '@ionic/react';
import { Button } from 'react-bootstrap';
import { axius, func, types } from 'utils';
import { Spin } from 'antd';
import moment from 'moment';
import _ from 'lodash';

interface Props {
    item: types.Order;
    state: types.StateProps;

    onChange: (item: types.Order) => void;
}
const OrderButtons = ({ item, state, onChange }: Props) => {

    const { _data: { location }, _auth: { user } } = state;

    const [presentToast] = useIonToast();
    const [presentAlert] = useIonAlert();

    const [loading, setLoading] = React.useState(false);
    const [unclaimed, setUnclaimed] = React.useState(0);

    const show = item.status === types.OrderStatus.ARRIVED;
    const updates = _.invert(item.statusHistory);
    let startTime = updates[types.OrderStatus.ARRIVED];

    React.useEffect(() => {
        if (startTime) {
            const endTime = moment(startTime).add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss');
            const interval = setInterval(() => {
                const tl = func.secondsUntil(endTime);
                if (show && tl > 0) {
                    setUnclaimed(tl);
                    // console.log('OrderTimer', { tl, startTime, endTime, current: moment().format('YYYY-MM-DD HH:mm:ss') });
                } else {
                    setUnclaimed(0);
                    clearInterval(interval);
                }
            }, 1 * 1000);

            return () => clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime, unclaimed]);

    const changeStatus = (status: types.OrderStatus, endpoint: string = '') => {
        updateOrder({ status }, (res: types.AxiusResponse) => {
            if (res.status === 200) {
                presentToast({ message: `Order status changed with success`, duration: 1500 });
            }
        }, endpoint);
        // return;
        // const header = {
        //     [types.OrderStatus.UNCLAIMED]: `Mark as Unclaimed`,
        //     [types.OrderStatus.ARRIVED]: `Check-In`,
        //     [types.OrderStatus.DELIVERY]: `Start Delivery`,
        //     [types.OrderStatus.ACCEPTED]: `Accept Delivery`,
        //     [types.OrderStatus.REJECTED]: `Reject Delivery`,
        // };
        // const message = {
        //     [types.OrderStatus.UNCLAIMED]: `This will change the order to a pickup.`,
        //     [types.OrderStatus.ARRIVED]: `This will notify the customer that you have arrived.`,
        //     [types.OrderStatus.DELIVERY]: `Only start if you have the package in your possession.`,
        // };
        // presentAlert({
        //     header: header[status as keyof typeof header],
        //     message: message[status as keyof typeof message],
        //     buttons: [
        //         { text: 'CANCEL' },
        //         {
        //             text: 'SUBMIT', handler: (v) => {
        //                 updateOrder({ status, ...v }, (res: types.AxiusResponse) => {
        //                     if (res.status === 200) {
        //                         presentToast(`Order status changed with success`, 1500);
        //                     }
        //                 }, endpoint);
        //             }
        //         },
        //     ],
        // });
    }

    const completeOrder = () => {
        presentAlert({
            header: `Complete Delivery`,
            message: `Input 4 digit code sent to the customer, to confirm delivery of this order`,
            inputs: [
                { type: 'number', name: 'code', placeholder: '• • • •', cssClass: 'text-center' },
            ],
            buttons: [
                { text: 'CANCEL' },
                {
                    text: 'SUBMIT', handler: (v) => {
                        if (v.code) {
                            updateOrder({ status: types.OrderStatus.COMPLETED, ...v }, (res: types.AxiusResponse) => {
                                if (res.status === 200) {
                                    presentToast({ message: `Order has been completed`, duration: 1500 });
                                }
                            }, '');
                        } else {
                            presentToast({ message: 'Confirmation code is required', duration: 1500 });
                        }
                    }
                },
            ],
        });
    }

    const updateOrder = (v: any, onOk: (e: any) => void, endpoint: string) => {
        setLoading(true);
        axius.put(`orders/${item.uuid}${endpoint}`, v).then(res => {
            if (res.status === 200) {
                onChange(res.data);
                onOk(res);
            } else {
                presentAlert(res.message);
            }
            setLoading(false);
        });
    }

    const distance = func.distanceMatrix(location, item.address, true);

    const riderStatus = item.riders.find(r => r.userId === user.id)?.status;

    return (
        <React.Fragment>
            <Spin spinning={loading} indicator={<span><i className="fa fa-spin fa-circle-notch" /></span>}>
                <div className="d-flex justify-content-between mt-3">
                    {riderStatus === types.OrderStatus.NEW && (
                        <>
                            <Button variant="success btn-md hide" onClick={() => changeStatus(types.OrderStatus.ACCEPTED, '/riders-orders')}>
                                &nbsp; Accept &nbsp;
                            </Button>
                            <Button variant="danger btn-md hide" onClick={() => changeStatus(types.OrderStatus.REJECTED, '/riders-orders')}>
                                &nbsp; Reject &nbsp;
                            </Button>
                        </>
                    )}

                    {/* {item.status === types.OrderStatus.READY && (
                        <Button variant="success btn-md" onClick={() => changeStatus(types.OrderStatus.DELIVERY)}>
                            &nbsp; Start Journey &nbsp;
                        </Button>
                    )} */}

                    {item.status === types.OrderStatus.ARRIVED && (
                        <>
                            <Button variant="success btn-md" onClick={() => completeOrder()}>
                                &nbsp; Complete &nbsp;
                            </Button>
                            <Button variant="danger btn-md" disabled={unclaimed > 0} onClick={() => changeStatus(types.OrderStatus.UNCLAIMED)}>
                                &nbsp; Unclaimed{unclaimed > 0 ? ` IN ${unclaimed > 60 ? `${(unclaimed / 60).toFixed(2)} MIN` : `${unclaimed.toFixed(0)} SEC`}` : ''} &nbsp;
                            </Button>
                        </>
                    )}

                    {location.x > 1 && item.status === types.OrderStatus.DELIVERY && (+distance <= 0.1 || func.isLocalOrStaging) && (
                        <Button variant="warning btn-md" onClick={() => changeStatus(types.OrderStatus.ARRIVED)}>
                            &nbsp; Check-In &nbsp;
                        </Button>
                    )}

                    {/* <Button variant="danger btn-md hide" onClick={() => router.push(`/orders-cancel`)}>
                    &nbsp; Cancel &nbsp;
                </Button> */}
                </div>
            </Spin>
        </React.Fragment>
    );
}

export default OrderButtons;